const REFERRER_KEY = 'ahc_referrer';

const read = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage no disponible: se degrada silenciosamente.
  }
};

const remove = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch {
    // No-op: storage no disponible.
  }
};

const isExternal = (referrer: string): boolean => {
  try {
    const { hostname } = new URL(referrer);
    const own = window.location.hostname.replace(/^www\./, '');

    return (
      hostname !== own &&
      !hostname.endsWith(`.${own}`) &&
      hostname !== 'auth0.com' &&
      !hostname.endsWith('.auth0.com')
    );
  } catch {
    return false;
  }
};

const isAuthCallback = (url: URL): boolean =>
  url.searchParams.has('code') || url.searchParams.has('state') || url.searchParams.has('error');

export const initReferrer = (): void => {
  if (read(REFERRER_KEY)) return;

  const referrer = document.referrer;
  if (referrer && isExternal(referrer)) {
    write(REFERRER_KEY, referrer);
    return;
  }

  const current = new URL(window.location.href);
  if (current.search && !isAuthCallback(current)) {
    write(REFERRER_KEY, current.href);
  }
};

export const getReferrer = (): string | null => read(REFERRER_KEY);

export const clearReferrer = (): void => {
  remove(REFERRER_KEY);
};
